import React from 'react';
import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import { formatDistanceToNow, format } from 'date-fns';

import { TBuild, TBuildName } from './MagicForm';

const BuildVersion = ({ build, name }: { build: TBuild; name: TBuildName }) => {
  if ('error' in build) return null;

  const lastCommitTime = new Date(build.lastCommitTime);

  return (
    <>
      <Divider textAlign="left" sx={{ mb: 1 }}>
        {formatBuildName(name)}
      </Divider>
      <Grid sx={{ wordBreak: 'break-all' }} container spacing={1}>
        <Grid size={2}>
          <Typography variant="body2" component="span">
            Version
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography variant="body2" component="span">
            {build.version}
          </Typography>
        </Grid>
        <Grid size={2}>
          <Typography variant="body2" component="span">
            Branch
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography variant="body2" component="span">
            {build.gitBranch}
          </Typography>
        </Grid>
        <Grid size={2}>
          <Typography variant="body2" component="span">
            Commit
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography variant="body2" component="span">
            <Tooltip title={build.gitSha}>
              <Typography variant="body2" component="span">
                {build.gitSha.slice(0, 7)}
              </Typography>
            </Tooltip>
          </Typography>
        </Grid>
        <Grid size={2}>
          <Typography variant="body2" component="span">
            Date
          </Typography>
        </Grid>
        <Grid size={4}>
          <Tooltip title={format(lastCommitTime, 'PPP HH:mm')}>
            <Typography variant="body2" component="span">
              {formatDistanceToNow(lastCommitTime)}
              {' ago'}
            </Typography>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  );
};

const formatBuildName = (str: TBuildName): string => {
  switch (str) {
    case 'webapp':
      return 'WebApp (Portal)';
    case 'mira':
      return 'Mira';
    case 'api':
      return 'API';
    case 'adk':
      return 'Test Runner';
    default:
      return str;
  }
};

export default BuildVersion;
